import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const gcpProjectIdValidatorFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'gcp-project-id-validator-form-field-extension',
    params: {
      field: () =>
        import('./gcp-project-id-validator').then(
          m => m.GCPProjectIdValidatorFormField,
        ),
    },
  });
